<template>
    <form @submit.prevent class="pre-login-form">
        <div class="pre-login-container" :class="{ '-vod': vod }">
            <img
                v-if="logo"
                class="pre-login-logo"
                @click="$emit('go-home')"
                :src="$env.getAppLogo().logo"
            />
            <div class="pre-login-progress" v-if="progress != null">
                <div :style="{ width: `${progress}%` }" />
            </div>
            <div class="pre-login-title" v-if="title">{{ $t(title) }}</div>
            <div style="height: 0.5rem" v-if="title"></div>
            <div class="pre-login-subtitle" v-if="subtitle">
                {{ $t(subtitle) }}
            </div>
            <slot />
        </div>
        <div class="login-actions-row" v-if="back">
            <TextButton label="BUTTON_BACK" @click="$emit('go-back')" />
        </div>
    </form>
</template>
<script>
export default {
    props: {
        logo: {
            type: Boolean,
            default: true
        },
        back: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        },
        subtitle: {
            type: String,
            default: ''
        },
        progress: {
            type: Number,
            default: null
        },
        vod: Boolean
    }
}
</script>
<style lang="scss">
.pre-login-form {
    display: flex;
    flex-direction: column;
    margin: auto;
    width: 500px;
}
.pre-login-container {
    position: relative;
    @include container;
    width: 100%;
    overflow: hidden;

    &.-vod {
        background: #2c2c2c;
        @media (max-width: $mobile) {
            background: #141414;
        }
    }
}
.pre-login-logo {
    width: 200px;
    cursor: pointer;
    margin: 0 0 1.5rem 0;

    @include button-hover;
}
.pre-login-title {
    @include header;
}
.pre-login-subtitle {
    @include paragraph;
    margin: 0.5rem 0.25rem;
}
.pre-login-progress {
    width: 100%;
    height: 0.3rem;
    background: $border-accent;
    position: absolute;
    top: 0;
    left: 0;

    div {
        background: $action-accent;
        height: 100%;
        transition: $ease;
    }
}
@media (max-width: $mobile) {
    .pre-login-form {
        width: 100vw;
    }
}
</style>
